import styled from "styled-components";

export const LoginWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LoginForm = styled.form`
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo };
  border: 1px solid ${({ theme }) => theme.colors.secundaria };
  border-radius: 4px;
  padding: 25px 20px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

export const LinkSecundario = styled.section`
  padding-left: 12px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;